<template>
  <div class="body">
    <img class="title_img" src="@/assets/img/title.png"/>
    <div class="title">
      <div class="title_left">
        <div class="title_left_info">
          <div>
            <span>全年累计入园（人次）</span>
            <span class="yellow">{{annual}}</span>
          </div>
          <div>
            <span>单日最大承载（人次）</span>
            <span class="yellow">{{sameDay}} &nbsp&nbsp&nbsp&nbsp </span>
            <span>瞬时最大承载（人次）</span>
            <span class="yellow">{{instant}}</span>
          </div>
        </div>
      </div>
      <div class="title_right">
        <div class="title_right_info">
          <div>
            <div style="display:inline-block;margin-top: .1rem;">游园舒适度&nbsp&nbsp&nbsp&nbsp</div>
<!--            <div class="choose" style="display:inline-block; color: rgb(248, 240, 35);">{{comfort}}</div>-->
            <div  style="display: inline-block;width: 1rem;height: 1rem;margin-top: -.1rem;">
              <img :src="comfort=='1' ? require('../assets/img/shushi.gif'): (comfort=='2' ? require('../assets/img/jiaoshushi.gif'):(comfort=='3' ? require('../assets/img/yiban.gif'):require('../assets/img/yongji.gif')))"/>
            </div>
<!--            <div style="display:inline-block;margin-top: .1rem;margin-left: .2rem;margin-right: .2rem">天气</div>-->
<!--            <div class="qx_info">-->
<!--              <div><img class="tq_img3" :src="weatherInfoImg"/>{{weatherInfoQw}}</div>-->
<!--              <div v-if="weatherInfoTem"><img class="tq_img1" src="@/assets/img/wd.png"/>{{weatherInfoTem}}℃</div>-->
<!--              <div v-if="weatherInfoRhu"><img class="tq_img2" src="@/assets/img/sd.png"/>{{weatherInfoRhu}}%</div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="main_part">
      <div class="left_part">
        <div class="left_part_1">
          <img class="part_img_1" src="@/assets/img/border_1.png"/>
          <img class="part_img_2" src="@/assets/img/border_2.png"/>
          <img class="part_img_3" src="@/assets/img/border_3.png"/>
          <img class="part_img_4" src="@/assets/img/border_4.png"/>
          <div class="part1_title">
            <div class="jrtj">今日统计</div>
          </div>
          <div class="jrtj_info">
            <div class="part1_info">
              <div class="ryrc"><div>入园(人次)</div></div>
              <div class="ryrc_num"><div>{{allPassengerFlowNum.inNum}}</div></div>
              <div class="ryrc"><div>预约数(人次)</div></div>
              <div class="ryrc_num"><div>{{sameDayStatistics.yuYue}}</div></div>
            </div>
            <div class="part1_info">
              <div class="ryrc"><div>在园(人次)</div></div>
              <div class="ryrc_num"><div>{{allPassengerFlowNum.existNum}}</div></div>
              <div class="ryrc"><div>已入园(人次)</div></div>
              <div class="ryrc_num"><div>{{sameDayStatistics.ruYuan}}</div></div>
            </div>
            <div class="part1_info">
              <div class="ryrc"><div>出园(人次)</div></div>
              <div class="ryrc_num"><div>{{allPassengerFlowNum.outNum}}</div></div>
              <div class="ryrc"><div>未入园(人次)</div></div>
              <div class="ryrc_num"><div>{{sameDayStatistics.weiRuYuan}}</div></div>
            </div>
          </div>
        </div>
        <div class="left_part_2">
          <div class="left_part_3">
            <div class="part2_title">入园监控</div>
            <div class="door_1 door_1_padding_top" v-for="item in nvrList">
              <div>{{item.cameraName}}</div>
              <div class="nvr"><iframe :src="item.flowUrl" allowfullscreen allow="autoplay"
                           border="0" marginwidth="0" marginheight="0" scrolling="no" allowtransparency="yes"></iframe></div>
              <div @click="showNvr(item.cameraName)"></div>
            </div>
          </div>
          <div class="left_part_4">
            <div class="left_part_5">
              <img class="part_img_1" src="@/assets/img/border_1.png"/>
              <img class="part_img_2" src="@/assets/img/border_2.png"/>
              <img class="part_img_3" src="@/assets/img/border_3.png"/>
              <img class="part_img_4" src="@/assets/img/border_4.png"/>
              <div class="part1_title">
                <div class="jrtj">各入口统计</div>
              </div>
              <div class="data_table">
                <img src="@/assets/img/jx_1.png" />
                <div>
                  <div></div>
                  <div>入园人次</div>
                  <div>出园人次</div>
                </div>
              </div>
              <div class="data_table_tr">
              <ul>
                <li>
                  <div>1号口</div>
                  <div style="color: rgb(248, 240, 35)">{{onePassengerFlowNum.inNum}}</div>
                  <div style=" color: rgb(238, 55, 245);">{{onePassengerFlowNum.outNum}}</div>
                </li>
              </ul>
              <ul>
                <li>
                  <div>2号口</div>
                  <div style="color: rgb(248, 240, 35)">{{twoPassengerFlowNum.inNum}}</div>
                  <div style=" color: rgb(238, 55, 245);">{{twoPassengerFlowNum.outNum}}</div>
                </li>
              </ul>
              <ul>
                <li>
                  <div>3号口</div>
                  <div style="color: rgb(248, 240, 35)">{{threePassengerFlowNum.inNum}}</div>
                  <div style=" color: rgb(238, 55, 245);">{{threePassengerFlowNum.outNum}}</div>
                </li>
              </ul>
            </div>

            </div>
            <div class="left_part_5" style="margin-top: .25rem">
              <img class="part_img_1" src="@/assets/img/border_1.png"/>
              <img class="part_img_2" src="@/assets/img/border_2.png"/>
              <img class="part_img_3" src="@/assets/img/border_3.png"/>
              <img class="part_img_4" src="@/assets/img/border_4.png"/>
              <div class="part1_title" >
                <div class="jrtj">停车场车位统计</div>
              </div>
              <div class="data_table1">
                <img src="@/assets/img/jx_1.png" />
                <div>
                  <div></div>
                  <div>总车位</div>
                  <div>已使用</div>
                  <div>空闲</div>
                </div>
              </div>
              <div class="data_table_tr1">
                <ul>
                  <li>
                    <div>1号停车场</div>
                    <div style="color: rgb(248, 240, 35)">{{parkingSpace.oneSpaceCount}}</div>
                    <div style="color: rgb(248, 240, 35)">{{parkingSpace.oneSpaceCount - parkingSpace.oneFreeSpaceCount}}</div>
                    <div style="color: rgb(248, 240, 35)">{{parkingSpace.oneFreeSpaceCount}}</div>
                  </li>
                </ul>
                <ul>
                  <li>
                    <div>2号停车场</div>
                    <div style="color: rgb(248, 240, 35)">{{parkingSpace.twoSpaceCount}}</div>
                    <div style="color: rgb(248, 240, 35)">{{parkingSpace.twoSpaceCount - parkingSpace.twoFreeSpaceCount}}</div>
                    <div style="color: rgb(248, 240, 35)">{{parkingSpace.twoFreeSpaceCount}}</div>
                  </li>
                </ul>
                <ul>
                  <li>
                    <div>3号停车场</div>
                    <div style="color: rgb(248, 240, 35)">{{parkingSpace.threeSpaceCount}}</div>
                    <div style="color: rgb(248, 240, 35)">{{parkingSpace.threeSpaceCount - parkingSpace.threeFreeSpaceCount}}</div>
                    <div style="color: rgb(248, 240, 35)">{{parkingSpace.threeFreeSpaceCount}}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right_part">
        <div class="right_part_1">
          <img class="part_img_1" src="@/assets/img/border_1.png"/>
          <img class="part_img_2" src="@/assets/img/border_2.png"/>
          <img class="part_img_3" src="@/assets/img/border_3.png"/>
          <img class="part_img_4" src="@/assets/img/border_4.png"/>
          <div class="part1_title" >
            <div class="jrtj">今日预约统计</div>
          </div>
          <div class="excel_1">
            <div class="excel_1_1">
            <div class="data_table3">
              <img src="@/assets/img/jx_1.png" />
              <div class="table3">各时段预约入园人数</div>
            </div>
              <div id="gsdrs" class="gsdrs"> </div>

            </div>
            <div class="excel_1_2">
              <div class="data_table3">
                <img src="@/assets/img/jx_1.png" />
                  <div class="table3">近期预约入园人数</div>
              </div>
              <div id="jqyyrs" class="jqyyrs"> </div>
            </div>
          </div>
          <div class="excel_2">
            <div class="data_table3">
              <img src="@/assets/img/jx_1.png" />
                <div class="table3">公园售票类型分布图</div>
            </div>
            <div  id="gysplx" class="gysplx"> </div>
          </div>

        </div>
        <div class="right_part_2">
          <img class="part_img_1" src="@/assets/img/border_1.png"/>
          <img class="part_img_2" src="@/assets/img/border_2.png"/>
          <img class="part_img_3" src="@/assets/img/border_3.png"/>
          <img class="part_img_4" src="@/assets/img/border_4.png"/>
          <div class="part1_title" >
            <div class="jrtj">今日游客画像</div>
          </div>
          <div class="excel_3">
            <div class="data_table2" style="height: calc(100% - 0.3rem)">
              <img src="@/assets/img/jx_1.png" />
                <div class="table4" style="width: 100%;text-align: left;margin-left: .2rem">来源地</div>
              <div class="lyd">
                <div v-if="this.num0 !=0">
                  <div>No.1</div>
                  <div>{{this.useCardName1}}</div>
                  <div>{{this.num0}}</div>
                </div>
                <div v-if="this.num1 !=0">
                  <div>No.2</div>
                  <div>{{this.useCardName2}}</div>
                  <div>{{this.num1}}</div>
                </div>
                <div v-if="this.num2 !=0">
                  <div>No.3</div>
                  <div>{{this.useCardName3}}</div>
                  <div>{{this.num2}}</div>
                </div>
                <div v-if="this.num3 !=0">
                  <div>No.4</div>
                  <div>{{this.useCardName4}}</div>
                  <div>{{this.num3}}</div>
                </div>
                <div v-if="this.num4 !=0">
                  <div>No.5</div>
                  <div>{{this.useCardName5}}</div>
                  <div>{{this.num4}}</div>
                </div>
              </div>
            </div>

          </div>
          <div class="excel_4">
            <div class="data_table2" style="margin-left: .1rem;">
              <img src="@/assets/img/jx_1.png" style="calc(100% - 0.1rem)"/>
                <div class="table4" style="width: 100%;text-align: left;margin-left: .2rem">年龄分布</div>
            </div>
            <div id="nlfb" class="nlfb"> </div>


          </div>
          <div class="excel_5">
            <div class="data_table2">
              <img src="@/assets/img/jx_1.png" />
                <div class="table4" style="width: calc(100% - .2rem);text-align: left;margin-left: .2rem">性别比</div>
            </div>
            <div id="xbb" class="xbb"> </div>
          </div>
        </div>

      </div>
    </div>
    <div class="playNvr" v-if="isShowNvr">
      <div class="nvrTitle"><div class="close" @click="closNvrUrl">X</div></div>
      <div class="nvrUrl" v-for="item in nvrList" v-if="item.cameraName==showNvrUrl">
        <iframe :src="item.flowUrl" allowfullscreen allow="autoplay"
                border="0" marginwidth="0" marginheight="0" scrolling="no" allowtransparency="yes"></iframe>
      </div>
<!--      <div class="nvrUrl">-->
<!--        <iframe :src="isShowNvr" allowfullscreen allow="autoplay"-->
<!--                border="0" marginwidth="0" marginheight="0" scrolling="no" allowtransparency="yes"></iframe>-->
<!--      </div>-->
    </div>
  </div>

</template>

<script>
  let echarts = require('echarts/lib/echarts');
  import {getNvrList,getPassengerFlowList,getSameDayStatistics,passengerFlow,getParkingSpace,getSameDayStatisticsTime} from '../api/statistics/statistics.js';
  import {data} from '../common/js/provincesutil';
  export default {
    name: "pc_dp",
    data() {
      return{
        nvrList:'',
        annual:'',
        sameDay:'',
        instant:'',
        sameDayStatistics:'',
        sameDayStatisticsTime:'',
        option : {},
        Time:[],
        useCardName1:'',
        useCardName2:'',
        useCardName3:'',
        useCardName4:'',
        useCardName5:'',
        yMax:0,
        passengerFlowNum:{},
        onePassengerFlowNum:{},
        twoPassengerFlowNum:{},
        threePassengerFlowNum:{},
        allPassengerFlowNum:{},
        comfort:'1', //1:舒适,2:较舒适,3:一般,4:拥挤,
        parkingSpace:{},  //停车场
        showNvrUrl:"",
        isShowNvr:false,
        num0:0,
        num1:0,
        num2:0,
        num3:0,
        num4:0,
        time:[],
        timeNumber:[],
        weatherInfoTem:"",
        weatherInfoRhu:"",
        weatherInfoImg:"", //气温图标
        weatherInfoQw:"", //气温情况
      }
    },
    created() {
      this.getNvrInfo();
      this.init_data();
      setInterval(this.init_data, 30000);
    },
    mounted(){

    },
    methods: {
      getNvrInfo(){
        // 查询nvr信息
        getNvrList().then((res) => {
          if (res.code==200){
            this.nvrList = res.data;
            console.log(this.nvrList);
            for (var i = 0; i < this.nvrList.length; i++) {
              this.nvrList[i].flowUrl = this.nvrList[i].flowUrl + "&autoplay=true";
            }
          }
        })
      },
      init_data() {
          //查询客流
        passengerFlow().then((res) => {
          console.log(res);
          if (res.code==200){
            console.log(res);
            this.passengerFlowNum = res.data;
            this.onePassengerFlowNum = res.data.OEN_PASSENGERFLOW;
            this.twoPassengerFlowNum = res.data.TWO_PASSENGERFLOW;
            this.threePassengerFlowNum = res.data.THREE_PASSENGERFLOW;
            this.allPassengerFlowNum = res.data.TOTAL_PASSENGERFLOW;
            this.weatherInfoTem = res.data.weatherInfoTem;
            this.weatherInfoRhu = res.data.weatherInfoRhu;
            this.weatherInfoQw = res.data.weatherInfoQw;
            this.weatherInfoImg = res.data.weatherInfoImg;
            this.comfort = res.data.COMFORT;
          }else if (res.code==403){
            this.$router.push({
              path: '/pc_login'
            })
            return;
          }
        }),
          //查询停车场
          getParkingSpace().then((res) => {
          if (res.code==200){
            console.log(res);
            this.parkingSpace = res.data;
          }
        }),
        getPassengerFlowList().then((res)=>{
          console.log(res.data[0]);
          if (res.code==200){
            if (res.data[0].annual == null){
              this.annual='000'
            }
            if (res.data[0].sameDay == null){
              this.sameDay='000'
            }
            if (res.data[0].instant == null){
              this.instant='000'
            }
            this.annual = res.data[0].annual;
            this.sameDay = res.data[0].sameDay;
            this.instant = res.data[0].instant;
          }else {
            this.annual = '000';
            this.sameDay = '000';
            this.instant = '000';
          }
        }),
        getSameDayStatistics().then((res)=>{
          if (res.code==200){
            this.sameDayStatistics = res.data;
            console.log(this.sameDayStatistics);
            this.Time = [];
            this.Time.push(this.sameDayStatistics.fiveTime);
            this.Time.push(this.sameDayStatistics.fourTime);
            this.Time.push(this.sameDayStatistics.twoTime+this.sameDayStatistics.threeTime);
            this.Time.push(this.sameDayStatistics.oneTime);
            this.yMax = this.sameDayStatistics.fiveTime+this.sameDayStatistics.fourTime+this.sameDayStatistics.threeTime+this.sameDayStatistics.twoTime+this.sameDayStatistics.oneTime;


            let city = data.province;
            if (this.sameDayStatistics.sourceList.length == 1) {
              var useCard1 = this.sameDayStatistics.sourceList[0].useCard+"0000";
              this.useCardName1 =city[useCard1];
              this.num0 = this.sameDayStatistics.sourceList[0].num;
            }else if (this.sameDayStatistics.sourceList.length == 2){
              var useCard1 = this.sameDayStatistics.sourceList[0].useCard+"0000";
              var useCard2 = this.sameDayStatistics.sourceList[1].useCard+"0000";
              this.useCardName1 =city[useCard1];
              this.useCardName2 =city[useCard2];
              this.num0 = this.sameDayStatistics.sourceList[0].num;
              this.num1 = this.sameDayStatistics.sourceList[1].num;
            }else if (this.sameDayStatistics.sourceList.length == 3){
              var useCard1 = this.sameDayStatistics.sourceList[0].useCard+"0000";
              var useCard2 = this.sameDayStatistics.sourceList[1].useCard+"0000";
              var useCard3 = this.sameDayStatistics.sourceList[2].useCard+"0000";
              this.useCardName1 =city[useCard1];
              this.useCardName2 =city[useCard2];
              this.useCardName3 =city[useCard3];
              this.num0 = this.sameDayStatistics.sourceList[0].num;
              this.num1 = this.sameDayStatistics.sourceList[1].num;
              this.num2 = this.sameDayStatistics.sourceList[2].num;
            } else if (this.sameDayStatistics.sourceList.length == 4){
              var useCard1 = this.sameDayStatistics.sourceList[0].useCard+"0000";
              var useCard2 = this.sameDayStatistics.sourceList[1].useCard+"0000";
              var useCard3 = this.sameDayStatistics.sourceList[2].useCard+"0000";
              var useCard4 = this.sameDayStatistics.sourceList[3].useCard+"0000";
              this.useCardName1 =city[useCard1];
              this.useCardName2 =city[useCard2];
              this.useCardName3 =city[useCard3];
              this.useCardName4 =city[useCard4];
              this.num0 = this.sameDayStatistics.sourceList[0].num;
              this.num1 = this.sameDayStatistics.sourceList[1].num;
              this.num2 = this.sameDayStatistics.sourceList[2].num;
              this.num3 = this.sameDayStatistics.sourceList[3].num;
            }else if (this.sameDayStatistics.sourceList.length == 5){
              var useCard1 = this.sameDayStatistics.sourceList[0].useCard+"0000";
              var useCard2 = this.sameDayStatistics.sourceList[1].useCard+"0000";
              var useCard3 = this.sameDayStatistics.sourceList[2].useCard+"0000";
              var useCard4 = this.sameDayStatistics.sourceList[3].useCard+"0000";
              var useCard5 = this.sameDayStatistics.sourceList[4].useCard+"0000";
              this.useCardName1 =city[useCard1];
              this.useCardName2 =city[useCard2];
              this.useCardName3 =city[useCard3];
              this.useCardName4 =city[useCard4];
              this.useCardName5 =city[useCard5];
              this.num0 = this.sameDayStatistics.sourceList[0].num;
              this.num1 = this.sameDayStatistics.sourceList[1].num;
              this.num2 = this.sameDayStatistics.sourceList[2].num;
              this.num3 = this.sameDayStatistics.sourceList[3].num;
              this.num4 = this.sameDayStatistics.sourceList[4].num;
            }
          }
          console.log(this.Time);
          this.$nextTick(function () {
            this.drawLine();
          });
        }),
        getSameDayStatisticsTime().then((res)=>{
          if (res.code==200){
            this.sameDayStatisticsTime = res.data;
            console.log(this.sameDayStatisticsTime);
          }
          this.$nextTick(function () {
            this.drawLines();
          });
        })
      },
      showNvr(nvrUrl){
        console.log(nvrUrl)
        this.isShowNvr = true;
        this.showNvrUrl = nvrUrl;
      },
      closNvrUrl(){
        this.isShowNvr = false;
      },
      drawLines(){
        let myChart2 = echarts.init(document.getElementById('jqyyrs'));
        window.onresize = myChart2.resize;
        var isSet2 = true; // 为了做判断：当鼠标移动上去的时候，自动高亮就被取消
        var charPie3currentIndex2 = 0;
        // myChart2.dispatchAction({
        //   type: 'highlight',
        //   seriesIndex: 0,
        //   dataIndex: 0
        // });
        // myChart2.dispatchAction({
        //   type: 'showTip',
        //   seriesIndex: 0,
        //   dataIndex: 0
        // });
        var option2 = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            top:'15%',
            bottom: '1%',
            left:'12%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: [this.sameDayStatisticsTime.time1,this.sameDayStatisticsTime.time2, this.sameDayStatisticsTime.time3, this.sameDayStatisticsTime.time4, this.sameDayStatisticsTime.time5, this.sameDayStatisticsTime.time6, this.sameDayStatisticsTime.time7],
            axisLabel: {
              interval:0,
              rotate:30,
              color: '#ffffff',
              fontSize : 10
            },
            axisTick:{       //x轴刻度线
              show:false
            },
            splitLine: { // 网格线
              show: true,
              lineStyle: {
                color: '#1f3a5f'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#1f3a5f'
              }
            },
          },
          yAxis: {
            type: 'value',
            splitLine: { // 网格线
              show: true,
              lineStyle: {
                color: '#1f3a5f'
              }
            },
            axisTick: {
              show: false, // 是否显示坐标轴轴线
            },
            axisLabel: { //坐标轴刻度标签的相关设置。
              show: false,
              // margin: 50,//距离
            },
          },
          series: [
            {
              type: 'line',
              data: [this.sameDayStatisticsTime.timeNumber1, this.sameDayStatisticsTime.timeNumber2, this.sameDayStatisticsTime.timeNumber3, this.sameDayStatisticsTime.timeNumber4, this.sameDayStatisticsTime.timeNumber5, this.sameDayStatisticsTime.timeNumber6, this.sameDayStatisticsTime.timeNumber7],
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                    offset: 0,
                    color: '#ffcc00'
                  }, {
                    offset: 1,
                    color: '#c13a41'
                  }]),
                  label : {
                    show: false,
                    color: '#ffffff'
                  }
                }
              },
              // markPoint: {
              //   data: [
              //     {type: 'max', name: '最大值'},
              //     {type: 'min', name: '最小值'}
              //   ]
              // }
            },
          ]
        };

        myChart2.clear();
        myChart2.setOption(option2);
        clearInterval(myChart2.startCharts);
        // 2、鼠标移动上去的时候的高亮动画
        myChart2.on('mouseover', function (param) {
          isSet2 = false;
          clearInterval(myChart2.startCharts);
          // 取消之前高亮的图形
          myChart2.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: charPie3currentIndex2
          });
          // 高亮当前图形
          myChart2.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: param.dataIndex
          });
          // 显示 tooltip
          myChart2.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: param.dataIndex
          });
        });
        // 3、自动高亮展示
        var chartHover2 = function () {
          var dataLen1 = option2.series[0].data.length;
          // 取消之前高亮的图形
          myChart2.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: charPie3currentIndex2
          });
          charPie3currentIndex2 = (charPie3currentIndex2 + 1) % dataLen1;
          // 高亮当前图形
          myChart2.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: charPie3currentIndex2
          });
          // 显示 tooltip
          myChart2.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: charPie3currentIndex2
          });
        };
        myChart2.startCharts = setInterval(chartHover2, 2000);
        // 4、鼠标移出之后，恢复自动高亮
        myChart2.on('mouseout', function (param) {
          if (!isSet2) {
            myChart2.startCharts = setInterval(chartHover2, 2000);
            isSet2 = true;
          }
        });
      },
      drawLine(){
        // let bar_dv = this.$refs.bar_dv;
        console.log("22222222")
        let myChart = echarts.init(document.getElementById('gsdrs'));
        window.onresize = myChart.resize;
        myChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: 0
        });
        myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: 0
        });
        // 绘制图表

        var dataShadows = [];
        for (let i = 0; i < this.Time.length; i++) {
          dataShadows.push(this.yMax);
        }
        var maxdata=dataShadows[0];
        for(var n=1;n<dataShadows.length;n++){
          if(dataShadows[n]>maxdata){
            maxdata=dataShadows[n];
          }
        }
        var dataShadow = [];
        for (let i = 0; i < this.Time.length; i++) {
          dataShadow.push(maxdata);
          console.log(dataShadow);
        }

        var option = {
          grid: {
            left: '16%',
            right: '25%',
            bottom: '10%',
            top:'10%',
            containLabel: false
          },
          yAxis: [{
            type: 'category',
            data: ['15-18时', '12-15时', '9-12时', '6-9时'],
            axisLabel: {
              color: '#ffffff'
            }
          },{
            type: 'category',
            data: ['15-18时', '12-15时', '9-12时', '6-9时'],
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
          },],
          xAxis: {
            type: 'value',
            splitLine: { // 网格线
              show: true,
              lineStyle: {
                color: '#3f51b5'
              }
            },
            axisTick: {
              show: false, // 是否显示坐标轴轴线
            },
            axisLabel: { //坐标轴刻度标签的相关设置。
              show: false,
            },
            axisLine:{
              show:false
            }
          },
          series: [{
            type: 'bar',
            barGap: '100%',
            zlevel: 1,
            yAxisIndex:1,
            data: dataShadow,
            barMaxWidth: 15,
            itemStyle: {
              normal: {
                color: '#0f2051',
                borderWidth: 0,
                shadowBlur: {
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                  shadowBlur: 10,
                  shadowOffsetY: 0,
                },
              }
            },
          },{
            data: this.Time,
            type: 'bar',
            barGap: '100%',
            barMaxWidth: 15,
            zlevel: 2,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                  type: 'linear',
                  offset: 0,
                  color: '#114389'
                }, {
                  offset: 1,
                  color: '#148dfe'
                }]),
              }
            },
            label:{
              show:true,
              position:'right',
              color: '#ffffff'
            }
          }]
        };
        myChart.clear();
        myChart.setOption(option);
        var myChart1 = echarts.init(document.getElementById('gysplx'));
        var isSet1 = true; // 为了做判断：当鼠标移动上去的时候，自动高亮就被取消
        var charPie3currentIndex1 = 0;

        //1、 创建静态echart表
        var option1 = {
          title: {
            left: 'center'
          },
          tooltip: {
            trigger: 'item'
          },
          grid: {
            right:'10%',
            containLabel: true
          },
          series: [{
            type: 'pie',
            radius: ['37%', '58%'],
            label:{
              show:true,
              color: '#ffffff'
            },

            axisLabel: {
              color: '#ffffff'
            },
            labelLine: {
              smooth: 0.2,
              length: 10,
              length2: 15
            },
            data: [
              {value: this.sameDayStatistics.ticketType1, name: '学生票数'},
              {value: this.sameDayStatistics.ticketType3, name: '免票数'},
              {value: this.sameDayStatistics.ticketType2, name: '老年票数'},
              {value: this.sameDayStatistics.ticketType0, name: '成人票数'},
            ],
            // data: [
            //   {value: 500, name: '学生票数'},
            //   {value: 500, name: '免票数'},
            //   {value: 500, name: '老年票数'},
            //   {value: 500, name: '成人票数'},
            // ],
            itemStyle: {
              //通常情况下：
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: function(params) {
                  var colorList = [
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#7f11f7'
                    }, {
                      offset: 1,
                      color: '#ed38ef'
                    }]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#fa755a'
                    }, {
                      offset: 1,
                      color: '#fa542b'
                    }]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#2948d5'
                    }, {
                      offset: 1,
                      color: '#1d5bd8'
                    }]),
                    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#fb9d0a'
                    }, {
                      offset: 1,
                      color: '#f9e21d'
                    }]),
                  ]; //每根柱子的颜色
                  return colorList[params.dataIndex];
                }
              },
            },
          }
          ]
        };
        myChart1.clear();
        myChart1.setOption(option1);
        clearInterval(myChart1.startCharts);
        // 2、鼠标移动上去的时候的高亮动画
        myChart1.on('mouseover', function (param) {
          isSet1 = false;
          clearInterval(myChart1.startCharts);
          // 取消之前高亮的图形
          myChart1.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: charPie3currentIndex1
          });
          // 高亮当前图形
          myChart1.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: param.dataIndex
          });
          // 显示 tooltip
          myChart1.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: param.dataIndex
          });
        });
        // 3、自动高亮展示
        var chartHover1 = function () {
          var dataLen1 = option1.series[0].data.length;
          // 取消之前高亮的图形
          myChart1.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: charPie3currentIndex1
          });
          charPie3currentIndex1 = (charPie3currentIndex1 + 1) % dataLen1;
          // 高亮当前图形
          myChart1.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: charPie3currentIndex1
          });
          // 显示 tooltip
          myChart1.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: charPie3currentIndex1
          });
        };
        myChart1.startCharts = setInterval(chartHover1, 2000);
        // 4、鼠标移出之后，恢复自动高亮
        myChart1.on('mouseout', function (param) {
          if (!isSet1) {
            myChart1.startCharts = setInterval(chartHover1, 2000);
            isSet1 = true;
          }
        });





        let myChart3 = echarts.init(document.getElementById('nlfb'));
        window.onresize = myChart3.resize;

        var isSet3 = true; // 为了做判断：当鼠标移动上去的时候，自动高亮就被取消
        var charPie3currentIndex3 = 0;
        // myChart3.dispatchAction({
        //   type: 'highlight',
        //   seriesIndex: 0,
        //   dataIndex: 0
        // });
        // myChart3.dispatchAction({
        //   type: 'showTip',
        //   seriesIndex: 0,
        //   dataIndex: 0
        // });
        var option3={
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            bottom: '19%',
            top:'14%',
            right:'6%',
            containLabel: false
          },
          xAxis: [
            {
              type: 'category',
              data: ['6岁以下','6-25岁','26-35岁','36-45岁','46-59岁','60-64岁','65岁以上'],
              axisTick: {
                alignWithLabel: true,
              },
              axisLabel: {
                margin: 10,//距离
                interval: 0,
                color: '#ffffff',
                fontSize : 10
              },
              triggerEvent: true,
              axisLine: {
                lineStyle: {
                  color: '#3f51b5'
                }
              },
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLine: {
                show: false
              },
              splitLine: { // 网格线
                show: true,
                lineStyle: {
                  color: '#3f51b5'
                }
              },
              axisLabel: {
                textStyle: {
                  color: '#708acc'
                }
              }
            }
          ],
          series: [
            {
              data: [this.sameDayStatistics.oneYear, this.sameDayStatistics.twoYear, this.sameDayStatistics.threeYear, this.sameDayStatistics.fourYear, this.sameDayStatistics.fiveYear, this.sameDayStatistics.sixYear, this.sameDayStatistics.sevenYear],
              type: 'bar',
              barWidth: '50%',
              label:{
                show:true,
                position:'top',
                color:"#0efcff"
              },
              itemStyle: {
                //通常情况下：
                normal: {
                  //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                  color: function(params) {
                    var colorList = [
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#fb7f9d'
                      }, {
                        offset: 1,
                        color: '#fb406d'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#fe9b1a'
                      }, {
                        offset: 1,
                        color: '#fe421b'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#4ae4a0'
                      }, {
                        offset: 1,
                        color: '#05bc79'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#67e0e3'
                      }, {
                        offset: 1,
                        color: '#0282de'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#ac93fd'
                      }, {
                        offset: 1,
                        color: '#7853f1'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#fed701'
                      }, {
                        offset: 1,
                        color: '#fc9501'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#0282de'
                      }, {
                        offset: 1,
                        color: '#3f29d0'
                      }]),
                    ]; //每根柱子的颜色
                    return colorList[params.dataIndex];
                  }
                },
              }
            }
          ]
        };
        myChart3.clear();
        myChart3.setOption(option3);
        clearInterval(myChart3.startCharts);
        // 2、鼠标移动上去的时候的高亮动画
        myChart3.on('mouseover', function (param) {
          isSet2 = false;
          clearInterval(myChart3.startCharts);
          // 取消之前高亮的图形
          myChart3.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: charPie3currentIndex2
          });
          // 高亮当前图形
          myChart3.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: param.dataIndex
          });
          // 显示 tooltip
          myChart3.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: param.dataIndex
          });
        });
        // 3、自动高亮展示
        var chartHover3 = function () {
          var dataLen1 = option3.series[0].data.length;
          // 取消之前高亮的图形
          myChart3.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: charPie3currentIndex3
          });
          charPie3currentIndex3 = (charPie3currentIndex3 + 1) % dataLen1;
          // 高亮当前图形
          myChart3.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: charPie3currentIndex3
          });
          // 显示 tooltip
          myChart3.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: charPie3currentIndex3
          });
        };
        myChart3.startCharts = setInterval(chartHover3, 2000);
        // 4、鼠标移出之后，恢复自动高亮
        myChart3.on('mouseout', function (param) {
          if (!isSet3) {
            myChart3.startCharts = setInterval(chartHover3, 2000);
            isSet3 = true;
          }
        });

        let myChart4 = echarts.init(document.getElementById('xbb'));
        window.onresize = myChart4.resize;
        myChart4.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: 0
        });
        myChart4.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: 0
        });
        var option4={
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            bottom: '19%',
            top:'20%',
            right: '25%',
            containLabel: false
          },
          xAxis: {
            type: 'category',
            data: ['男性', '女性'],
            axisLabel: {
              color: '#ffffff',
              fontSize : 10
            },
          },
          yAxis: {
            type: 'value',
            show:false,
          },
          series: [{
            data: [this.sameDayStatistics.yNv, this.sameDayStatistics.xNan],
            type: 'bar',
            barWidth: "15", //柱图宽度
            label:{
              show:true,
              position:'top',
            },
            itemStyle: {
              //通常情况下：
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: function(params) {
                  var colorList = [
                    "#3288e0",
                    "#ffd52d",
                  ]; //每根柱子的颜色
                  return colorList[params.dataIndex];
                },
                barBorderRadius: 15
              },
              emphasis: {
                barBorderRadius: 15
              },
            }
          }]
        };
        myChart4.clear();
        myChart4.setOption(option4);
      },
    }
  }
</script>

<style scoped>
  /* body, html {
     !*width: 100%;*!
     !*height: 100%;*!
     background: url("../assets/img/bg.png") no-repeat;
     background-size: 100% 100%;
   }*/
  .body {
    width: 100%;
    height: 100%;
    background: url("../assets/img/bg.gif") no-repeat;
    background-size: 100% 100%;
  }

  .title_img {
    width: 100%;
    position: absolute;
    top: 0;
  }

  .title {
    /*height: 1.31rem;*/
    /*line-height: 1.31rem;*/
    position: relative;
    top: 0.6rem;
    padding-bottom: .3rem;
  }

  .title_left {
    display: inline-block;
    width: 50%;
  }

  .title_right {
    display: inline-block;
    width: 36%;
    margin-left: 13%;
    vertical-align: top;
  }

  .title_left_info {
    /*display: inline-block;*/
    width: 100%;
    margin-left: .4rem;
  }

  .title_left_info div {
    font-size: .2rem;
    font-family: "SourceHanSansCN";
    color: rgb(1, 237, 252);
    line-height: 1.5;
    text-align: left;
  }

  .title_right_info div {
    font-size: .2rem;
    font-family: "SourceHanSansCN";
    color: rgb(1, 237, 252);
    text-align: left;
    line-height: .68rem;
    height: .68rem;
    vertical-align: top;
  }

  .title_right_info img {
    height: 100%;
    width: 100%;
    vertical-align: top;
  }

  .choose {
    background: url("../assets/img/title_choose.png") no-repeat center;
    background-size: 150% 100%;
    height: .68rem;
  }

  .main_part {
    margin-top: 0.6rem;
    margin-left: .4rem;
    margin-right: .4rem;
    width: calc(100% - .8rem);
    height: calc(100% - 1.9rem);
  }

  .left_part {
    vertical-align: top;
    display: inline-block;
    width: 42%;
    height: 100%;
  }

  .left_part_1 {
    position: relative;
    border: 1px solid rgb(53, 143, 255);
    height: 25%;
    width: calc(100% - 2px);
  }

  .part_img_1 {
    position: absolute;
    top: -0.03rem;
    left: -0.03rem;
    width: .3rem;
    height: .22rem;
  }

  .part_img_2 {
    position: absolute;
    top:-0.03rem;
    right:-0.03rem;
    width: .3rem;
    height: .22rem;
  }

  .part_img_3 {
    position: absolute;
    bottom: -0.03rem;
    left: -0.03rem;
    width: .3rem;
    height: .22rem;
  }

  .part_img_4 {
    position: absolute;
    bottom:-0.03rem;
    right: -0.03rem;
    width: .3rem;
    height: .22rem;
  }

  .part1_title {
    width: 100%;
    height: .48rem;
    background-color: rgba(0, 94, 210, 0.2);
  }

  .jrtj_info{
    height: calc(100% - .52rem);
    width: 100%;
    padding-top: .04rem;
  }

  .jrtj {
    font-size: .2rem;
    font-family: "SourceHanSansCN";
    color: rgb(254, 255, 255);
    line-height: 0.5rem;
    margin-left: .3rem;
  }

  .part1_info {
    width: 100%;
    height: calc((100% - 0.57rem) / 3);
    margin-top: 0.13rem;

  }

  .part1_info > div {
    display: inline-block;
    width: 1.48rem;
    height: 100%;
    font-size: .18rem;
    font-family: "SourceHanSansCN";
    line-height: 100%;
  }

  .ryrc {
    background-color: rgba(1, 196, 252, 0.2);
    color: rgb(9, 203, 239);
    margin-left: 0.4rem;
  }

  .ryrc div{
    display:flex;
    align-items:center;/*垂直居中*/
    justify-content: center;/*水平居中*/
    width:100%;
    height:100%;
  }

  .ryrc_num div{
    display:flex;
    align-items:center;/*垂直居中*/
    justify-content: center;/*水平居中*/
    width:100%;
    height:100%;
  }

  .ryrc_num {
    background-color: rgba(29, 41, 99, 0.702);
    color: rgb(254, 255, 255);
  }

  .left_part_2 {
    width: 100%;
    height: 71%;
    margin-top: 4%;
  }

  .left_part_3 {
    width: 33%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
  }

  .part2_title {
    background: url("../assets/img/title_bg.png") no-repeat center;
    background-size: 100% 100%;
    height: .5rem;
    font-size: .2rem;
    font-family: "SourceHanSansCN";
    color: rgb(254, 255, 255);
    line-height: .5rem;
    text-align: center;
  }

  .door_1 {
    height: calc((100% - .55rem) / 3);
  }

  .door_1_padding_top {
    padding-top: .05rem;
  }

  .door_1 div:first-child {
    font-size: 0.2rem;
    font-family: "SourceHanSansCN";
    color: rgb(255, 255, 255);
    line-height: .41rem;
    height: .41rem;
    width: 100%;
  }
  .door_1 .nvr {
    height: calc(100% - .41rem);
    width: 100%;
    overflow: hidden;
  }

  .door_1 div:last-child {
    height: calc(100% - .41rem);
    width: 100%;
    background-color: transparent;
    margin-top: -1.57rem;
    position: relative;
  }

  .img_jk {
    width: 100%;
    height: 100%;
  }

  .left_part_4 {
    height: 100%;
    width: calc(64% - 0.3rem);
    display: inline-block;
    vertical-align: top;
    float: right;
    margin-right: .03rem;
  }
  .left_part_5 {
    border: 1px solid rgb(53, 143, 255);
    height: calc((100% - .31rem)/2);
    width: 100%;
    position: relative;
    font-family: "SourceHanSansCN";
  }
  .right_part {
    vertical-align: top;
    display: inline-block;
    width: 55%;
    height: 100%;
    float: right;
  }
  .right_part_1 {
    border: 1px solid rgb(53, 143, 255);
    height: calc((71% - .31rem)/2 + 29%);
    width: calc(100% - 2px);
    position: relative;
  }
  .right_part_2 {
    border: 1px solid rgb(53, 143, 255);
    height: calc((71% - .31rem)/2);
    width: 100%;
    position: relative;
    margin-top: .25rem;
  }
  .data_table {
     margin-top: .23rem;
     position: relative;
     padding: 0 0.3rem ;
   }

  .data_table img {
    position: absolute;
    top: 0;
    width: calc(100% - 0.6rem);
    height: .55rem;
  }

  .data_table>div {
    height: .55rem;
    line-height: .55rem;
  }

  .data_table>div>div {
    display: inline-block;
    width: 30%;
    text-align: center;
    font-size: .18rem;
    color: rgb(10, 218, 255);
    vertical-align: top;
  }

  .data_table_tr {
    margin-top: .02rem;
    height: calc(100% - 1.45rem);
    overflow: auto;
    padding: 0 0.3rem ;
  }

  .data_table_tr ul {
    height: calc((100% - .02rem)/3);
  }
  .data_table_tr ul:not(:last-child) {
    border-bottom: .01rem solid rgba(1, 237, 252, 0.239);
  }

  .data_table_tr ul li div {
    font-family: "SourceHanSansCN";
    display: inline-block;
    width: 30%;
    font-size: .17rem;
    text-align: center;
    color: rgb(255, 255, 255);
    white-space: nowrap;
  }
  .data_table1 {
    margin-top: .23rem;
    position: relative;
    padding: 0 0.3rem ;
  }


  .data_table1 img {
    position: absolute;
    top: 0;
    width: calc(100% - 0.6rem);
    height: .55rem;
  }

  .data_table1>div {
    height: .55rem;
    line-height: .55rem;
  }

  .data_table1>div>div {
    display: inline-block;
    width: 23%;
    text-align: center;
    font-size: .18rem;
    color: rgb(10, 218, 255);
    vertical-align: top;
  }

  .data_table_tr1 {
    margin-top: .02rem;
    height: calc(100% - 1.45rem);
    overflow: auto;
    padding: 0 0.3rem ;
  }

  .data_table_tr1 ul {
    height: calc((100% - .02rem)/3);
  }
  .data_table_tr1 ul:not(:last-child) {
    border-bottom: .01rem solid rgba(1, 237, 252, 0.239);
  }

  .data_table_tr1 ul li div {
    font-family: "SourceHanSansCN";
    display: inline-block;
    width: 23%;
    font-size: .17rem;
    text-align: center;
    color: rgb(255, 255, 255);
    white-space: nowrap;
  }
  .excel_1 {
    width: calc(49% - .4rem);
    height: calc(100% - .9rem);
    display: inline-block;
    padding: 0.2rem 0 .2rem .3rem;
    vertical-align: top;
  }
  .excel_2 {
    width: calc(49% - .4rem);
    height: calc(100% - .9rem);
    display: inline-block;
    padding: 0.2rem 0 .2rem .3rem;
    vertical-align: top;
  }
  .data_table3 {
    position: relative;

  }
  .data_table3 img {
    position: absolute;
    top: 0;
    width: calc(100% - 2.2rem);
    height: .55rem;
  }
  .table3 {
    width: calc(100% - 2.2rem);
    display: inline-block;
    font-size: .2rem;
    text-align: center;
    line-height: .55rem;
    color: rgb(10, 218, 255);
  }
  .excel_1_1 {
    width: 100%;
    height: 44%;
  }
  .excel_1_2 {
    width: 100%;
    height: 56%;
  }
  .excel_3 {
    width: 24%;
    height: calc(100% - .5rem);
    display: inline-block;
    vertical-align: top;
  }
  .excel_4 {
    width: 48%;
    height:calc(100% - .5rem);
    display: inline-block;
    vertical-align: top;
  }
  .excel_5 {
    width: 24%;
    height: calc(100% - .5rem);
    display: inline-block;
    vertical-align: top;
  }
  .yellow {
    color: rgb(248, 240, 35)
  }
  .table4 {
    width: calc(100% - 2.2rem);
    display: inline-block;
    font-size: .18rem;
    font-family: "SourceHanSansCN";
    color: rgb(10, 218, 255);
    line-height: .37rem;
    height: .37rem;
    vertical-align: top;
}
  .data_table2 {
    margin-top: .23rem;
    position: relative;
    margin-left: .2rem;
  }

  .data_table2 img {
    position: absolute;
    top: 0;
    width: calc(100% - 0.2rem);
    height: .37rem;
  }

   .lyd {
     width: calc(100% - .1rem);
     height: calc(100% - .37rem - .23rem);
     margin-left: .1rem;
   }
   .lyd >div {
     font-size: .17rem;
     font-family: "SourceHanSansCN";
     color: rgb(248, 240, 35);
     line-height:2.3;
     text-align: left;
     height: calc(100%/5);
   }
  .lyd >div >div {
    width: 31%;
    display: inline-block;
  }
  .lyd >div >div:nth-child(2) {
    width: 33%;
  }
  .gsdrs {
    width: 100%;
    height: calc(100% - .55rem) ;
  }
  .jqyyrs {
    width: 100%;
    height: calc(100% - .65rem) ;
    margin-top: .1rem;
    background-color: #05244f;
  }
  .gysplx {
    width: 100%;
    height: calc(100% - .55rem) ;
  }
  .nlfb {
    width: calc(100% - .15rem);
    height: calc(100% - .55rem - .23rem);
    margin-left: .08rem;
  }
  .xbb {
    width: calc(100% - .15rem);
    height: calc(100% - .65rem - .10rem);
    margin-left: .15rem;
  }

  iframe {
    margin-top: -.41rem;
    width: 125%;
    height: 118%;
    margin-left: -.32rem;
  }

  .playNvr{
    background-color: #011029;
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    filter: alpha(opacity=60);
    z-index: 1111111111;
  }

  .playNvr .nvrTitle{
    background-color: rgba(0, 94, 210, 0.2);
    height: .48rem;
    width: 100%;
  }
  .playNvr .nvrTitle .close {
    font-family: "SourceHanSansCN";
    font-size: .4rem;
    width: .48rem;
    height: 100%;
    line-height: .48rem;
    color: #7e8c8d;
    font-weight: bold;
    float: right;
    margin-right: .12rem;
  }

  .playNvr .nvrUrl{
    height: calc(100% - .48rem);
    width: 100%;
    overflow: hidden;
  }

  .playNvr .nvrUrl iframe{
    margin-top: -.45rem;
    width: 125%;
    height: 103.8%;
    margin-left: -2.4rem;
  }

  .qx_info{
    display: inline-block;
    line-height: .86rem !important;
    font-size: .17388rem !important;
    font-family: "Adobe Heiti Std" !important;
    color: rgb(248, 240, 35) !important;
  }

  .qx_info div{
    display: inline-block;
    line-height: .68rem!important;
    margin-right: .18rem;
    margin-top: 0.1rem;
    color: #f8f023!important;
  }

  .qx_info img{
    width: .24rem;
    height: .24rem;
    margin-top: 0.21rem;
    /*margin-left: .24rem;*/
    margin-right: .09rem;
  }

  .qx_info .tq_img3{
    width: .3rem;
    height: .3rem;
  }

  .qx_info .tq_img2{
    width: .19rem;
    height: .25rem;
  }


  .tqinfo1{
    height: .26rem!important;
    overflow: hidden;
    top: .3rem;
    position: relative;
    width: 1.7rem;
  }

  .tqinfo1 div{
    position: relative;
    width: 1.8rem;
    height: .34rem!important;
    z-index: 99;
    top: -.1rem;
  }

  .tqinfo1 iframe{
    position: absolute;
    top: -0.1rem;
    margin-top: 0;
    margin-left: 0;
    /*height: .22rem!important;*/
    width: 1.7rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/pc_dp.vue